import { uuid } from 'vue-uuid';

export const up = (pageContent) => {
    const hasZIndex = Object.keys(pageContent).includes('zIndex');
    const hasId = Object.keys(pageContent).includes('id');
    if (!hasZIndex) {
        pageContent.zIndex = 0;
    }

    if (!hasId) {
        pageContent.id = uuid.v1();
    }
    
    return pageContent;
}